import axios from 'axios'

export type TrustpilotRatings = {
  starsAverage: number
  numberOfReviews: {
    total: number
    oneStar: number
    twoStars: number
    threeStars: number
    fourStars: number
    fiveStars: number
  }
}

export type TrustpilotReview = {
  id?: string
  stars: number
  content: string
  createdAt: string
  consumer: { displayName: string }
  isImported: boolean
}

export type TrustpilotReviews = {
  reviews: TrustpilotReview[]
  count: number
}

export const REVIEWS_DISPLAY_THRESHOLD = 10

export function formatDate(iso: string): string {
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ''
  return `${String(d.getDate()).padStart(2, '0')}/${String(
    d.getMonth() + 1
  ).padStart(2, '0')}/${String(d.getFullYear()).slice(2)}`
}

const headers = {
  'x-api-key': process.env.TRUSTPILOT_REVIEWS_API_KEY as string
}

export function getTrustpilotRatings(
  productType: string
): Promise<TrustpilotRatings> {
  return axios
    .get(`${process.env.TRUSTPILOT_REVIEWS_API_DOMAIN}/ratings`, {
      params: { productType },
      headers
    })
    .then(({ data }) => data)
}

export function getTrustpilotReviews(
  productType: string,
  page = 1,
  pageSize = 20
): Promise<TrustpilotReviews> {
  return axios
    .get(`${process.env.TRUSTPILOT_REVIEWS_API_DOMAIN}/reviews`, {
      params: { productType, page, pageSize },
      headers
    })
    .then(({ data }) => data)
}

export function getTrustpilotBestReviews(
  productType: string,
  numReviews = 10
): Promise<TrustpilotReviews> {
  return axios
    .get(`${process.env.TRUSTPILOT_REVIEWS_API_DOMAIN}/best-reviews`, {
      params: { productType, numReviews },
      headers
    })
    .then(({ data }) => data)
}
